var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8852 15.3886C13.9326 15.3886 15.5922 13.7289 15.5922 11.6816C15.5922 9.63429 13.9326 7.97461 11.8852 7.97461C9.83791 7.97461 8.17822 9.63429 8.17822 11.6816C8.17822 13.7289 9.83791 15.3886 11.8852 15.3886Z",
    stroke: "white",
    strokeWidth: 2.47134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8854 1.79639C9.26359 1.79639 6.74921 2.83788 4.89535 4.69174C3.04149 6.5456 2 9.05998 2 11.6817C2 14.0196 2.49674 15.5494 3.8535 17.2422L11.8854 26.5098L19.9172 17.2422C21.274 15.5494 21.7707 14.0196 21.7707 11.6817C21.7707 9.05998 20.7292 6.5456 18.8753 4.69174C17.0215 2.83788 14.5071 1.79639 11.8854 1.79639V1.79639Z",
    stroke: "white",
    strokeWidth: 2.47134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.0a2e6d5c45dffec31a357af44f78115e.svg";
export { ForwardRef as ReactComponent };